"use client";

import React from "react";
import Link from "next/link";
import { ExternalLink } from "lucide-react";
import { Avatar } from "@/components/ui/avatar";
import { Client } from "@/lib/types/database";
import type { ColleagueCardProps } from "./types";

export const ColleagueCard: React.FC<ColleagueCardProps> = ({ colleague }) => {
  return (
    <Link
      href={`/contacts/${colleague.id}`}
      className="flex items-center gap-3 p-3 rounded-lg border hover:bg-card-50 transition-colors group"
    >
      <Avatar className="h-8 w-8">
        <div className="w-full h-full bg-blue-100 flex items-center justify-center dark:bg-blue-900/40">
          <span className="text-blue-600 text-sm font-medium dark:text-blue-400">
            {colleague.name.charAt(0).toUpperCase()}
          </span>
        </div>
      </Avatar>

      <div className="flex-1 min-w-0">
        <div className="font-medium text-card-foreground truncate">{colleague.name}</div>
        <div className="text-sm text-gray-500 truncate">
          {colleague.title && (
            <>
              {colleague.title}
              {colleague.email && " • "}
            </>
          )}
          {colleague.email}
        </div>
      </div>

      <ExternalLink className="h-4 w-4 text-gray-400 group-hover:text-gray-600 flex-shrink-0" />
    </Link>
  );
};
